import React, { Component } from 'react';
import Button from 'react-bootstrap/lib/Button';
import {isTouchDevice} from '../utils/Browser';

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

const TouchButton = React.createClass({
    render() {
        let props = _objectWithoutProperties(this.props, ['onTouchTap', 'onClick']);
        if (isTouchDevice()) {
            props.onTouchTap = this.props.onTouchTap || this.props.onClick;
        } else {
            props.onClick = this.props.onClick || this.props.onTouchTap;
        }
        return <Button {...props}></Button>;
    }
});

export default TouchButton;


/** WEBPACK FOOTER **
 ** ./src/components/TouchButton.js
 **/